import React, { useEffect, useState } from 'react';
import {  useRoutes, Navigate, Router } from 'react-router';
import "./App.css";
import  Home  from "./pages/home"
import  Login  from "./pages/login"
import  Register  from "./pages/register"
import AuthLayout from './layouts/AuthLayout';
import AppLayout from './layouts/AppLayout';
import { useAuth } from './context/AuthContext';
function App() {
  const { isAuthenticated, setIsAuthenticated } = useAuth();
  const [ipAddress, setIpAddress] = useState('1.1.1.1');
  
  const routes = useRoutes([
    {
      path: '/',
      element: isAuthenticated ? <Navigate to="/home" /> : <Navigate to="/login" />
    },
    {
      path: '/',
      element: <AuthLayout />,  
      children: [
        { path: '/login', element: <Login /> },
        { path: '/register', element: <Register /> }
      ]
    },
    {
      path: '/home',
      element: isAuthenticated ? <AppLayout><Home ipAddress={ipAddress} /></AppLayout> : <Navigate to="/login" />
    },
    {
      path: '*',
      element: <div>404 - Page Not Found</div>
    }
  ]);
  useEffect(() => {
    console.log("sessionStorage userData: ", sessionStorage.getItem('userData'));
    setIsAuthenticated(!!sessionStorage.getItem('userData'));
  }, [setIsAuthenticated]);

  return <>{routes}</>;
}
export default App;
